module.exports = __webpack_public_path__ + "img/2021AllotteeVisayasInvitation.f82a44fd.jpg";